export const messages = {
  en: {
    feeDiscountManage: {
      search: {
        title: 'Search Conditions',
        discountId: 'Please enter discount ID',
        discountName: 'Please enter discount name',
        discountType: 'Please select discount type',
        ruleName: 'Please enter rule name'
      },
      list: {
        title: 'Discount Information'
      },
      table: {
        discountId: 'Discount ID',
        discountName: 'Discount Name',
        discountType: 'Discount Type',
        ruleName: 'Rule Name',
        rule: 'Rule',
        createTime: 'Create Time',
        operation: 'Operation'
      },
      add: {
        title: 'Add Discount',
        discountName: 'Discount Name',
        discountNamePlaceholder: 'Required, please enter discount name',
        discountNameRequired: 'Discount name cannot be empty',
        discountNameMaxLength: 'Discount name cannot exceed 256 characters',
        discountType: 'Discount Type',
        discountTypePlaceholder: 'Required, please select discount type',
        discountTypeRequired: 'Discount type cannot be empty',
        rule: 'Rule',
        rulePlaceholder: 'Required, please select rule',
        ruleRequired: 'Rule cannot be empty',
        discountDesc: 'Description',
        discountDescPlaceholder: 'Optional, please enter description',
        specValueRequired: '{specName} cannot be empty'
      },
      edit: {
        title: 'Edit Discount',
        discountName: 'Discount Name',
        discountNamePlaceholder: 'Required, please enter discount name',
        discountNameRequired: 'Discount name cannot be empty',
        discountNameMaxLength: 'Discount name cannot exceed 256 characters',
        discountType: 'Discount Type',
        discountTypePlaceholder: 'Required, please select discount type',
        discountTypeRequired: 'Discount type cannot be empty',
        rule: 'Rule',
        rulePlaceholder: 'Required, please select rule',
        ruleRequired: 'Rule cannot be empty',
        discountDesc: 'Description',
        discountDescPlaceholder: 'Optional, please enter description',
        discountIdRequired: 'Discount ID cannot be empty',
        specValueRequired: '{specName} cannot be empty'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this fee discount?'
      }
    }
  },
  zh: {
    feeDiscountManage: {
      search: {
        title: '查询条件',
        discountId: '请输入折扣ID',
        discountName: '请输入折扣名称',
        discountType: '请选择折扣类型',
        ruleName: '请输入规则名称'
      },
      list: {
        title: '折扣信息'
      },
      table: {
        discountId: '折扣ID',
        discountName: '折扣名称',
        discountType: '折扣类型',
        ruleName: '规则名称',
        rule: '规则',
        createTime: '创建时间',
        operation: '操作'
      },
      add: {
        title: '添加折扣',
        discountName: '折扣名称',
        discountNamePlaceholder: '必填，请填写折扣名称',
        discountNameRequired: '折扣名称不能为空',
        discountNameMaxLength: '折扣名称不能超过256位',
        discountType: '折扣类型',
        discountTypePlaceholder: '必填，请选择折扣类型',
        discountTypeRequired: '折扣类型不能为空',
        rule: '规则',
        rulePlaceholder: '必填，请选择规则',
        ruleRequired: '规则不能为空',
        discountDesc: '描述',
        discountDescPlaceholder: '可选，请填写描述',
        specValueRequired: '{specName}不能为空'
      },
      edit: {
        title: '修改折扣',
        discountName: '折扣名称',
        discountNamePlaceholder: '必填，请填写折扣名称',
        discountNameRequired: '折扣名称不能为空',
        discountNameMaxLength: '折扣名称不能超过256位',
        discountType: '折扣类型',
        discountTypePlaceholder: '必填，请选择折扣类型',
        discountTypeRequired: '折扣类型不能为空',
        rule: '规则',
        rulePlaceholder: '必填，请选择规则',
        ruleRequired: '规则不能为空',
        discountDesc: '描述',
        discountDescPlaceholder: '可选，请填写描述',
        discountIdRequired: '折扣ID不能为空',
        specValueRequired: '{specName}不能为空'
      },
      delete: {
        title: '请确认您的操作',
        confirmText: '确定删除费用折扣'
      }
    }
  }
}